import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";

import { FunctionDefinition, SourceFunction } from "../functions/types";
import {
  DELETE_FUNCTION,
  SET_FUNCTIONS,
  UPSERT_FUNCTION,
  UPSERT_SOURCE_FUNCTION,
} from "../reducers/functions";
import { makeRequest } from "../util";

export const fetchFunctionDefinitions = (): ThunkAction<
  Promise<void>,
  any,
  unknown,
  AnyAction
> => {
  return async (dispatch) => {
    const { data: response } = await makeRequest<{
      function_defs: FunctionDefinition[];
      source_functions: SourceFunction[];
    }>("get_functions", {});

    if (response) {
      dispatch({
        type: SET_FUNCTIONS,
        payload: response,
      });
    }
  };
};

export const createFunctionDefinition = (
  functionDefinition: FunctionDefinition,
): ThunkAction<Promise<Error | void>, any, unknown, AnyAction> => {
  return async (dispatch) => {
    const { data: response } = await makeRequest<{
      functionDef: FunctionDefinition;
      err?: string;
    }>("create_new_function", functionDefinition);
    if (response.err) {
      throw new Error(response.err);
    }

    dispatch({ type: UPSERT_FUNCTION, payload: response.functionDef });
  };
};

export const updateFunctionDefinition = (
  functionDefinition: FunctionDefinition,
): ThunkAction<Promise<void>, any, unknown, AnyAction> => {
  return async (dispatch) => {
    await makeRequest<FunctionDefinition>(
      "update_function",
      functionDefinition,
    );

    dispatch({ type: UPSERT_FUNCTION, payload: functionDefinition });
  };
};

export const refreshFunctionDefinition = (
  functionId: string,
): ThunkAction<Promise<Error | void>, any, unknown, AnyAction> => {
  return async (dispatch) => {
    const { data: response } = await makeRequest<{
      functionDef: FunctionDefinition;
      err?: string;
    }>("refresh_function", {
      function_def_id: functionId,
    });
    if (response.err) {
      throw new Error(response.err);
    }

    dispatch({ type: UPSERT_FUNCTION, payload: response.functionDef });
  };
};

export const deleteFunctionDefinition = (
  functionId: string,
): ThunkAction<Promise<void>, any, unknown, AnyAction> => {
  return async (dispatch) => {
    await makeRequest<FunctionDefinition>("delete_function", {
      function_def_id: functionId,
    });

    dispatch({ type: DELETE_FUNCTION, payload: functionId });
  };
};

export const createSourceFunction = (
  sourceFunction: SourceFunction,
): ThunkAction<Promise<Error | void>, any, unknown, AnyAction> => {
  return async (dispatch) => {
    const { data: response } = await makeRequest<{
      sourceFunction: SourceFunction;
      err?: string;
    }>("create_new_source_function", sourceFunction);
    if (response.err) {
      throw new Error(response.err);
    }

    dispatch({
      type: UPSERT_SOURCE_FUNCTION,
      payload: response.sourceFunction,
    });
  };
};
